import { LoadingIndicator } from '@thoughtspot/radiant-react/widgets/loading-indicator';
import React, { useEffect } from 'react';
import { useBlinkContextForCOMS, useValidateBlinkContextForCOMS, } from "../../../contexts/coms-blink-context";
import { useBuildCommunicationConnection } from "../../../services/coms/coms-service";
import { CommunicationConnectionType } from "../../../services/generated/graphql-types";
export const ConnectorContainer = React.memo(({ connection, channel }) => {
    useValidateBlinkContextForCOMS();
    const { sessionService } = useBlinkContextForCOMS();
    const isSlackBotEnabled = sessionService.isSlackBotEnabled();
    const isMsTeamsBotEnabled = sessionService.isMsTeamsBotEnabled();
    const clusterName = sessionService.getClusterName();
    const { buildConnection, data } = useBuildCommunicationConnection();
    useEffect(() => {
        if (data && data?.redirectUrl) {
            window.location.assign(data.redirectUrl);
        }
    }, [data]);
    useEffect(() => {
        if (isSlackBotEnabled &&
            connection &&
            channel === CommunicationConnectionType.Slack) {
            buildConnection(CommunicationConnectionType.Slack, clusterName, connection);
        }
        if (isMsTeamsBotEnabled &&
            connection &&
            channel === CommunicationConnectionType.Msteams) {
            buildConnection(CommunicationConnectionType.Msteams, clusterName, connection);
        }
    }, [connection]);
    return (React.createElement(LoadingIndicator.Global, null,
        React.createElement(React.Fragment, null)));
});
//# sourceMappingURL=connector.container.js.map